import { useCallback, useEffect } from 'react';
import { useAiCreditsStore } from '../stores/aiCreditsStore';
import { useAuthStore } from '../stores/authStore';

export function useAiCredits() {
  const { 
    planCredits,
    maxPlanCredits,
    chargedCredits,
    maxChargedCredits,
    useCredit,
    loadCredits,
    isLoading,
    monthlyUsage
  } = useAiCreditsStore();
  
  const { user, isAuthenticated } = useAuthStore();
  
  // Load credits when component mounts or user changes
  useEffect(() => {
    if (isAuthenticated && user?.id) {
      loadCredits();
    }
  }, [isAuthenticated, user?.id, loadCredits]);

  const getLowCreditsThreshold = useCallback(() => {
    return Math.floor(maxPlanCredits * 0.1); // 10% of max plan credits
  }, [maxPlanCredits]);

  const generateWithAi = useCallback(async () => {
    try {
      await useCredit();
      return true;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`AIクレジットエラー: ${error.message}`);
      }
      throw error;
    }
  }, [useCredit]);

  return {
    planCredits,
    maxPlanCredits,
    chargedCredits,
    maxChargedCredits,
    monthlyUsage,
    isLoading,
    isLowCredits: planCredits <= getLowCreditsThreshold() && chargedCredits === 0,
    generateWithAi
  };
}